import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { homeFunctions } from '../../data/home';
import { fadeUp } from '../../utils/motion';

/** "How it works": three connected functions with links to deeper material. */
export function HomeFoundations() {
  return <section id="how-it-works" aria-labelledby="home-how-title" className="scroll-mt-20 bg-white border-b border-line py-20 lg:py-28" data-id="element-1144" data-mp="w5h80brigmvr">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1145" data-mp="idaocfp5fxrk">
        <motion.div {...fadeUp} className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12" data-id="element-1146" data-mp="n5u49jbb74zj">
          <h2 id="home-how-title" className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight" data-id="element-1147" data-mp="8i0p1zq4y4hh">
            How it works
          </h2>
          <a href="/how-it-works" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1148" data-mp="3vlnl5z9jyih4">
            The full explanation <ArrowRight size={16} aria-hidden="true" data-id="element-1149" data-mp="1m6a3hxfnsjup" />
          </a>
        </motion.div>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10" data-id="element-1150" data-mp="1h905hte7ezv9">
          {homeFunctions.map((item, index) => <motion.li key={item.id} {...fadeUp} className="flex flex-col border-t-2 border-navy pt-6" data-id="element-1151" data-mp="1w468s8lx0kkw" data-mpi={index}>
              <h3 className="flex items-center gap-3 font-heading font-bold text-2xl text-ink-dark leading-snug" data-id="element-1152" data-mp="1r6xq86wuuej4">
                <span aria-hidden="true" className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-teal/60 text-sm font-semibold text-teal" data-id="element-1153" data-mp="13epmztssw1xn">
                  {index + 1}
                </span>
                {item.title}
              </h3>
              <p className="mt-3 mb-6 text-ink-muted leading-relaxed" data-id="element-1154" data-mp="kq2ipdig7gl4">{item.body}</p>
              <a href={item.link.href} className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1155" data-mp="knzmgbqpcr7y">
                {item.link.label} <ArrowRight size={14} aria-hidden="true" data-id="element-1156" data-mp="19ff9aw244xji" />
              </a>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}